import { HttpRequestConfig } from "@repo/http"
import { cache } from "react"

import http from "../../../../utils"
import { MarketsInfo } from "./interface"

/**
 * 服务端获取用户信息
 * @returns 用户信息，如果未登录则返回 null
 */
export const getMarkets = cache(async (clientIP?: string | null) => {
  const httpConfig: HttpRequestConfig<null> = {
    // 使用 Next.js 缓存确保请求去重，避免重复请求
    // 60 秒缓存，确保同一渲染周期内的重复请求被去重
    next: { revalidate: 60, tags: ["header-markets"] },
  }
  if (clientIP) {
    httpConfig.getClientIP = () => clientIP
  }
  return http.get<null, MarketsInfo[]>(`/spotoverseascenter/v1/prices/category_list`, httpConfig)
})
